import { Btn } from "./UI";

const navItems = [
  { id: "dashboard", label: "Dashboard",  icon: "⬡" },
  { id: "jobs",      label: "My Jobs",    icon: "💼" },
  { id: "applicants",label: "Applicants", icon: "👥" },
];

export default function Sidebar({ tab, setTab, user, onLogout }) {
  return (
    <div style={{
      position: "fixed", top: 0, left: 0, bottom: 0, width: 240,
      background: "#0f172a", display: "flex", flexDirection: "column", zIndex: 100,
    }}>
      {/* Brand */}
      <div style={{ padding: "28px 24px 20px" }}>
        <div style={{ display: "flex", alignItems: "center", gap: 10, marginBottom: 28 }}>
          <div style={{
            width: 40, height: 40,
            background: "linear-gradient(135deg, #10b981, #059669)",
            borderRadius: 11, display: "flex", alignItems: "center",
            justifyContent: "center", fontSize: 19,
            boxShadow: "0 4px 14px rgba(16,185,129,0.35)",
          }}>💼</div>
          <div>
            <div style={{ color: "#fff", fontSize: 14, fontWeight: 700, fontFamily: "'Playfair Display', serif" }}>
              JobPortal
            </div>
            <div style={{ color: "#475569", fontSize: 11 }}>Agent Panel</div>
          </div>
        </div>

        {/* User card */}
        <div style={{
          background: "rgba(255,255,255,0.04)", borderRadius: 12,
          padding: "12px 14px", marginBottom: 24, border: "1px solid rgba(255,255,255,0.06)",
        }}>
          <div style={{ color: "#64748b", fontSize: 10, fontWeight: 700, textTransform: "uppercase", letterSpacing: "0.07em", marginBottom: 5 }}>
            Logged in as
          </div>
          <div style={{ color: "#f1f5f9", fontSize: 13, fontWeight: 700 }}>{user?.name || "Agent"}</div>
          <div style={{ color: "#475569", fontSize: 11, marginTop: 2, wordBreak: "break-all" }}>{user?.email}</div>
          <div style={{
            marginTop: 8, display: "inline-block",
            background: "rgba(16,185,129,0.12)", color: "#10b981",
            fontSize: 10, fontWeight: 700, padding: "2px 8px", borderRadius: 6,
            border: "1px solid rgba(16,185,129,0.2)",
          }}>
            {user?.role || "Agent"}
          </div>
        </div>

        {/* Nav */}
        <nav>
          {navItems.map(n => (
            <button
              key={n.id}
              onClick={() => setTab(n.id)}
              style={{
                display: "flex", alignItems: "center", gap: 10, width: "100%",
                padding: "10px 14px", borderRadius: 10, border: "none", cursor: "pointer",
                background: tab === n.id ? "rgba(16,185,129,0.15)" : "transparent",
                color: tab === n.id ? "#10b981" : "#64748b",
                fontSize: 14, fontWeight: tab === n.id ? 700 : 400,
                marginBottom: 4, fontFamily: "'DM Sans', sans-serif",
                transition: "all 0.15s", textAlign: "left",
                borderLeft: `3px solid ${tab === n.id ? "#10b981" : "transparent"}`,
              }}
            >
              <span style={{ fontSize: 16 }}>{n.icon}</span>
              {n.label}
            </button>
          ))}
        </nav>
      </div>

      {/* Footer / logout */}
      <div style={{ marginTop: "auto", padding: "16px 24px", borderTop: "1px solid rgba(255,255,255,0.05)" }}>
        <div style={{ color: "#334155", fontSize: 11, marginBottom: 10, textAlign: "center" }}>
          RasuTrip Websoft Technologies Llp
        </div>
        <button
          onClick={onLogout}
          style={{
            width: "100%", padding: "9px 14px",
            background: "rgba(239,68,68,0.08)", border: "1px solid rgba(239,68,68,0.18)",
            borderRadius: 10, color: "#f87171", fontSize: 13, fontWeight: 600,
            cursor: "pointer", fontFamily: "'DM Sans', sans-serif", transition: "opacity 0.15s",
          }}
          onMouseOver={e => (e.currentTarget.style.opacity = "0.75")}
          onMouseOut={e  => (e.currentTarget.style.opacity = "1")}
        >
          ← Sign Out
        </button>
      </div>
    </div>
  );
}